import JobDescription from "../../../components/jobdesc"
import { useDispatch } from 'react-redux';
import { ACTIONS } from "../../../redux/actions";
import { useEffect } from "react";


export default function JobsDescription({ secured = false }: any) {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch({
            type: ACTIONS.PAGE,
            pageSettings: {
                pageTitle: "Job Description",
                useFilter: false
            }
        })
        return () => {
            dispatch({
                type: ACTIONS.PAGE,
                pageSettings: {
                    pageTitle: "",
                    useFilter: true
                }
            })
        }
    }, [])
    return <>
        <JobDescription secured={secured} />
    </>
}